const EMAIL_REGEX =
  /^(?=.{1,64}@)[a-zA-Z0-9](([.-]?\w+)*)@{1}[a-zA-Z0-9](([.-]?\w+)*)(\.[A-Za-z]{2,})$/;
export const isValidEmail = (email: string): boolean => {
  if (email.endsWith('.con')) {
    return false;
  }
  return EMAIL_REGEX.test(email);
};
